<template>
  <div class="rb-header">
    <steps-bar :current-step="currentStep" :total-steps="totalSteps" />
    <div class="rb-header-content">
      <div class="rb-left">
        <steps-counter
          :current-step="currentStep"
          :total-steps="totalSteps"
          v-if="mode === 'nav'"
        />
        <button
          aria-label="Close Ring Builder"
          @click.prevent="endRingBuilder"
          class="rb-btn-back"
          id="btn-back"
          v-if="mode !== 'nav'"
        >
          <icon-back />
          <span>Back</span>
        </button>
      </div>
      <div class="rb-center">
        <img
          :src="logo"
          alt="Jean Dousset"
          class="lazyload main-logo"
          loading="lazy"
          @click.prevent="endRingBuilder"
        />
      </div>
      <div class="rb-right">
        <button
          class="rb-btn-close"
          aria-label="Close Ring Builder"
          @click.prevent="endRingBuilder"
          v-if="mode === 'nav'"
        >
          <icon-close />
        </button>
        <button
          aria-label="Save For Later"
          class="rb-btn-save"
          v-if="mode !== 'nav'"
          @click.prevent="notifySaveForLater"
          id="btn-save-for-later"
        >
          <template v-if="savedForLater">
            <span>Saved!</span>
            <icon-heart-full />
          </template>
          <template v-else>
            <span>Save For Later</span>
            <icon-heart />
          </template>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * Displays a header for the ERB when open in Fullscreen.
 * Shows Logo, navigation, progress and SFL button
 *
 * @props
 * currentStep: Number
 * totalSteps: Number
 * logo: String
 *
 * @implements
 * CommMixin
 * TrackMixin
 *
 * @mits
 * rb-open-popup
 * rb-save-for-later
 */
import CommMixin from "@/mixins/CommMixin";
import TrackMixin from "@/mixins/TrackMixin";
import StepsCounter from "@/components/StepsCounter";
import StepsBar from "@/components/StepsBar";
import IconClose from "@/components/icons/IconClose";
import IconHeart from "@/components/icons/IconHeart";
import IconHeartFull from "@/components/icons/IconHeartFull";
import IconBack from "@/components/icons/IconBack";
export default {
  mixins: [CommMixin, TrackMixin],
  components: {
    StepsCounter,
    StepsBar,
    IconClose,
    IconHeart,
    IconHeartFull,
    IconBack,
  },
  props: {
    currentStep: {
      type: Number,
      default: 1,
    },
    totalSteps: {
      type: Number,
      default: 1,
    },
    logo: {
      type: String,
    },
  },
  data: function () {
    return {
      savedForLater: false,
    };
  },
  computed: {
    mode: function () {
      return this.currentStep < this.totalSteps ? "nav" : "close";
    },
  },
  methods: {
    endRingBuilder: function () {
      this.trackEvent(
        this.formatTracking("btn-end-builder", this.TRACK_CLICK),
        "btn-end-builder"
      );
      this.broadcast("rb-open-popup", { id: "rb-popup-exit" });
    },
    notifySaveForLater: function (event) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
      this.broadcast("rb-save-for-later");
      setTimeout(() => {
        this.savedForLater = true;
      }, 500);
    },
  },
};
</script>
